import React from 'react';
import { Link } from 'react-router-dom';
import UnifiedFooter from '../../components/ui/UnifiedFooter';
import PublicNavigation from '../../components/ui/PublicNavigation';

const sections = [
  {
    id: 'editeur',
    title: '1. Éditeur du site',
    content: (
      <>
        <p className="mb-3">
          Le site <strong>ADT EXPRESS</strong> est une marque exploitée par :
        </p>
        <address className="not-italic bg-gray-50 border-l-4 border-green-700 pl-5 py-4 rounded-r-lg space-y-1 text-gray-700">
          <p className="font-semibold text-gray-900">TRANSIMPEX INTERNATIONAL SERVICES</p>
          <p>Société par actions simplifiée unipersonnelle (SASU)</p>
          <p>RCS Bobigny : <strong>990 952 806</strong></p>
          <p>Siège social : 34 Rue Hémet, 93300 Aubervilliers, France</p>
        </address>
      </>
    ),
  },
  {
    id: 'directeur',
    title: '2. Directeur de la publication',
    content: (
      <p>
        Le directeur de la publication est le représentant légal de la société{' '}
        <strong>TRANSIMPEX INTERNATIONAL SERVICES</strong>.
      </p>
    ),
  },
  {
    id: 'hebergement',
    title: '3. Hébergement',
    content: (
      <>
        <p className="mb-3">Le site est hébergé par :</p>
        <address className="not-italic bg-gray-50 border-l-4 border-green-700 pl-5 py-4 rounded-r-lg space-y-1 text-gray-700">
          <p className="font-semibold text-gray-900">Hostinger International Ltd</p>
          <p>61 Lordou Vironos Street, 6023 Larnaca, Chypre</p>
          <p>
            Site web :{' '}
            <a
              href="https://www.hostinger.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-700 hover:text-green-900 underline"
            >
              https://www.hostinger.fr
            </a>
          </p>
        </address>
      </>
    ),
  },
  {
    id: 'activite',
    title: '4. Activité',
    content: (
      <>
        <p className="mb-3">
          <strong>ADT EXPRESS</strong> est un service spécialisé dans :
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 pl-2">
          <li>le transport de colis</li>
          <li>le groupage maritime</li>
          <li>l'import-export de marchandises</li>
          <li>la logistique entre la France et l'Afrique, notamment la Côte d'Ivoire</li>
        </ul>
      </>
    ),
  },
  {
    id: 'propriete-intellectuelle',title: '5. Propriété intellectuelle',
    content: (
      <>
        <p className="mb-3">
          L'ensemble des contenus présents sur ce site (textes, images, logo, éléments graphiques) sont la
          propriété exclusive de <strong>TRANSIMPEX INTERNATIONAL SERVICES</strong>, sauf mention contraire.
        </p>
        <p>
          Toute reproduction, distribution ou utilisation sans autorisation préalable écrite est strictement
          interdite et constitue une contrefaçon sanctionnée par le Code de la propriété intellectuelle.
        </p>
      </>
    ),
  },
  {
    id: 'donnees-personnelles',
    title: '6. Données personnelles',
    content: (
      <>
        <p className="mb-3">
          Les informations collectées via le site (formulaires de contact, WhatsApp, suivi de colis) sont
          utilisées uniquement dans le cadre de la relation commerciale avec nos clients et prospects.
        </p>
        <p className="mb-3">
          Ces données ne sont ni vendues, ni cédées à des tiers à des fins commerciales.
        </p>
        <p>
          Conformément au Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679),
          tout utilisateur dispose d'un droit d'accès, de rectification, de suppression et de portabilité
          de ses données personnelles. Pour exercer ces droits, vous pouvez contacter l'entreprise àl'adresse :{' '}
          <a
            href="mailto:contact@adtexpress.fr"
            className="text-green-700 hover:text-green-900 underline"
          >
            contact@adtexpress.fr
          </a>
          .
        </p>
      </>
    ),
  },
  {
    id: 'responsabilite',
    title: '7. Responsabilité',
    content: (
      <>
        <p className="mb-3">
          <strong>TRANSIMPEX INTERNATIONAL SERVICES</strong> met tout en œuvre pour assurer l'exactitude
          et la mise à jour des informations diffusées sur le site ADT EXPRESS.
        </p>
        <p>
          Toutefois, la société ne saurait être tenue responsable des erreurs ou omissions dans les
          informations publiées, ni des éventuels dommages directs ou indirects résultant de l'utilisation du site ou de l'impossibilité d'y accéder.
        </p>
      </>
    ),
  },
];

const MentionsLegales = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicNavigation />
      <main className="flex-1">
        {/* Hero */}
        <div className="bg-green-900 text-white py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-green-300 text-sm font-medium mb-2 uppercase tracking-wider">
              Informations légales
            </p>
            <h1 className="text-3xl md:text-4xl font-bold">Mentions légales</h1>
            <p className="mt-3 text-green-200 text-sm">
              Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans
              l'économie numérique (LCEN).
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
          {/* Table of contents */}
          <nav className="mb-10 p-5 bg-gray-50 rounded-xl border border-gray-200">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">
              Sommaire
            </p>
            <ol className="space-y-1">
              {sections?.map((s) => (
                <li key={s?.id}>
                  <a
                    href={`#${s?.id}`}
                    className="text-green-700 hover:text-green-900 text-sm hover:underline"
                  >
                    {s?.title}
                  </a>
                </li>
              ))}
            </ol>
          </nav>

          {/* Sections */}
          <div className="space-y-10">
            {sections?.map((s) => (
              <section key={s?.id} id={s?.id} className="scroll-mt-24">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                  {s?.title}
                </h2>
                <div className="text-gray-700 leading-relaxed text-sm md:text-base">
                  {s?.content}
                </div>
              </section>
            ))}
          </div>

          {/* Back link */}
          <div className="mt-14 pt-6 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-green-700 hover:text-green-900 font-medium"
            >
              ← Retour à l'accueil
            </Link>
          </div>
        </div>
      </main>
      <UnifiedFooter />
    </div>
  );
};

export default MentionsLegales;
